import { render, staticRenderFns } from "./createNotifications.vue?vue&type=template&id=6168ebe2"
import script from "./createNotifications.vue?vue&type=script&lang=js"
export * from "./createNotifications.vue?vue&type=script&lang=js"
import style0 from "./createNotifications.vue?vue&type=style&index=0&id=6168ebe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports